import { useReviewingStore } from '@/stores/reviewingStore';
import { useToasterStore } from '@/stores/useToasterStore';
import { OfficeUtils } from '@/utils/office.utils';
import { useI18n } from 'vue-i18n';

export function useKeyPointsExport() {
  const reviewingStore = useReviewingStore();
  const toaster = useToasterStore();
  const { t } = useI18n();

  function getFormattedKeyPoints(): string {
    return reviewingStore.keyPointsResponse?.keyPoints
      .map((kp) => {
        return [
          `<b>${kp.title}</b>`,
          `<i>${kp.explanation}</i>`,
          kp.description
        ].join('\n\n');
      })
      .join('\n\n\n');
  }

  async function onCopyKeypoints() {
    try {
      await OfficeUtils.copyTextToClipboard(getFormattedKeyPoints());
      toaster.success({
        title: t('actions.toast.text_copied')
      });
    } catch {
      toaster.error({
        title: t('actions.toast.text_copied.error')
      });
    }
  }

  async function onInsertKeypoints() {
    try {
      await OfficeUtils.insertTextToDocument(getFormattedKeyPoints());
      toaster.success({
        title: t('actions.toast.text_inserted')
      });
    } catch {
      toaster.error({
        title: t('actions.toast.text_inserted.error')
      });
    }
  }

  return { onCopyKeypoints, onInsertKeypoints };
}
